import { createPostAsyncSlice } from '@sonar-software/xuder';
import { postRecommendedActionTemplateByUrl } from '@api';

export const postCoreDataSecurityActionTemplateByUrlSlice = createPostAsyncSlice({
	name: 'CoreDataSecurityActionTemplateByUrl',
	receive: true,
	request: true,
	requestHandler: postRecommendedActionTemplateByUrl
});
